
































































































































































































import {
  Component,
  Prop,
  PropSync,
  Ref,
  Vue,
  Watch,
} from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { cloneDeep, isEqual } from "lodash";
import { Currency } from "@/shared/models/currency";
import { BusinessUnit } from "@/shared/models/businessUnit";
import { saveFile } from "@/shared/saveFile";
import { AppParam } from "@/shared/models/appParam";
import { PaymentSlipModel } from "../reservation-form/types";
import DateField from "@/components/misc/DateField.vue";
import TimeField from "@/components/misc/TimeField.vue";
import { TransactionDescription } from "@/shared/models/transactionDescriptionCodebooks";
import NumericInput from "../misc/NumericInput.vue";
import { CashRegisterModel } from "@/shared/models/cashRegister";
import VCustomer, { CustomerModel } from "@/shared/models/vCustomer";
import CustomerLookup from "@/components/misc/CustomerLookup.vue";
import {
  FinancialDocumentTypesEnum,
  TransactiontypeEnum,
} from "@/shared/models/enums.type";
import handleBrokenRuleAdapter from "@/shared/handleBrokenRuleAdapter";
import _ from "lodash";
import { FinancialSettingsType } from "@/store/modules/financial";
import {
  PaymentSlipSaveResult,
  PaymentSlipViewModel,
} from "./FinancialDocumentFormParts/models";

@Component({
  name: "PaymentSlipModalForm",
  components: {
    DateField,
    NumericInput,
    TimeField,
    CustomerLookup,
  },
})
export default class PaymentSlipModalForm extends Vue {
  @PropSync("open") isOpen?: boolean;
  @Prop() editingModel?: PaymentSlipModel;

  @Action("codebooks/refreshTransactiontypeDescriptions")
  refreshTransactiontypeDescriptions?: () => Promise<void>;
  @Getter("codebooks/transactionDescriptions")
  transactionDescriptions?: TransactionDescription[];

  @Getter("financial/settings") storedSettings?: FinancialSettingsType;

  financialDocumentTypesEnum = FinancialDocumentTypesEnum;

  async created() {
    const promises = [];
    if (
      this.transactionDescriptions?.length === 0 &&
      this.refreshTransactiontypeDescriptions
    ) {
      promises.push(this.refreshTransactiontypeDescriptions());
    }
    await Promise.all(promises);
  }

  @Watch("isOpen", { immediate: true })
  modelChanged(fresh: boolean, old: boolean) {
    if (fresh && !old && this.editingModel) {
      if (this.currencyItems.length === 1) {
        this.editingModel.currencyId = this.currencyItems[0].id ?? 0;
      }
      this.formRef?.resetValidation();
      this.original = cloneDeep(this.editingModel);
      this.current = cloneDeep(this.editingModel);
    }
  }

  original = null as PaymentSlipModel | null;

  current = null as PaymentSlipModel | null;

  loading = false;

  lookupOpen = false;
  clientInfoForm = false;

  get model() {
    return this.current;
  }

  get filterPrefil() {
    return {
      name: this.model?.customerName || "",
    };
  }

  get cashRegistersForBusinessUnit() {
    return (
      this.availableCashRegisters?.filter(
        (x) => x.businessUnitId === this.model?.businessUnitId
      ) ?? []
    );
  }
  get transactionDescriptionsForDocumentType() {
    if (this.model?.documentTypeId === FinancialDocumentTypesEnum.Uplatnica) {
      return this.transactionDescriptions?.filter(
        (x) => x.transactionTypeId === TransactiontypeEnum.Deposit
      );
    }
    if (this.model?.documentTypeId === FinancialDocumentTypesEnum.Isplatnica) {
      return this.transactionDescriptions?.filter(
        (x) => x.transactionTypeId === TransactiontypeEnum.Withdrawal
      );
    }
    return [];
  }

  get businessUnits() {
    return (
      this.availableBusinessUnits?.filter((x) => !x.isOwnerBusinessUnit) ?? []
    );
  }

  // prettier-ignore
  @Getter("appParams/formalCurrency") formalCurrency?: Currency;
  @Getter("appParams/workingCurrency") workingCurrency?: Currency;

  @Getter("appParams/appParams") appParams?: AppParam[];

  @Getter("businessUnit/availableBusinessUnits")
  availableBusinessUnits?: BusinessUnit[];
  @Getter("businessUnit/activeBusinessUnit") activeBusinessUnit?: BusinessUnit;

  @Getter("language/language") language?: string;

  @Getter("cashRegister/activeCashRegister")
  activeCashRegister?: CashRegisterModel;

  @Getter("cashRegister/availableCashRegisters")
  availableCashRegisters?: CashRegisterModel[];

  get isLocked() {
    return this.saving;
  }

  @Watch("model.customerName")
  nameWatch(fresh: string) {
    if (!fresh && this.model && this.model.id && this.model.id != 0) {
      this.model.customerId = null;
      this.model.customerName = "";
      this.selectedCustomer = null;
    }
  }

  get currencyItems() {
    if (this.formalCurrency?.id === this.workingCurrency?.id) {
      return [
        {
          id: this.formalCurrency?.id,
          text: this.formalCurrency?.isoCode,
        },
      ];
    } else {
      return [
        {
          id: this.formalCurrency?.id,
          text: this.formalCurrency?.isoCode,
        },
        {
          id: this.workingCurrency?.id,
          text: this.workingCurrency?.isoCode,
        },
      ];
    }
  }

  onInputLostFocus() {
    if (this.model) {
      if (this.selectedCustomer && this.model.customerName.length !== 0) {
        this.model.customerName = this.selectedCustomer.name;
      } else {
        this.model.customerId = null;
        this.model.customerName = "";
        this.selectedCustomer = null;
      }
    }
  }

  selectedCustomer: any = null;
  selected(customer: VCustomer | CustomerModel) {
    const tableCustomer = customer as VCustomer;
    const newCustomer = customer as CustomerModel;

    const isTableCustomer = typeof newCustomer.genderId === "undefined";

    let name = "";
    if (isTableCustomer) {
      name = tableCustomer.name;
    } else {
      if (newCustomer.isLegalEntity) {
        name = newCustomer.legalEntityName ?? "";
      } else {
        name = [
          newCustomer.firstName,
          newCustomer.middleName,
          newCustomer.lastName,
        ]
          .filter((x) => !!x && x.length > 0)
          .join(" ");
      }
    }

    if (this.model) {
      this.model.customerId = customer.id;
      this.model.customerName = name;
      this.selectedCustomer = _.cloneDeep(this.model);
    } else {
      this.selectedCustomer = undefined;
    }
  }

  get rules() {
    return {
      required: (value: any) =>
        !!value || this.$t("Validation.Required").toString(),
      maxDecimals: (value: any) =>
        !(this.countDecimals(+value) > 2) ||
        this.$t("Validation.CanOnlyHaveTwoDecimals"),
    };
  }

  maxLength(max: number) {
    return (v: string) =>
      !v || v.length <= max
        ? true
        : this.$t("Validation.MaxLength", { count: max });
  }

  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  get fiscalNumber() {
    if (this.model?.documentIdentifier != undefined) {
      return this.model.documentIdentifier;
    } else {
      return this.model?.documentInternalIdentifier;
    }
  }

  get title() {
    if (this.model?.documentTypeId === FinancialDocumentTypesEnum.Uplatnica) {
      return this.model.id != null
        ? this.$t("t.FinancialDocumentTypes.PaymentSlip.Deposit") +
            " " +
            (this.storedSettings?.setFiscalNumberAsMain
              ? this.fiscalNumber
              : this.model.documentInternalIdentifier)
        : this.$t("FinancialDocument.New.PaymentSlip.Deposit");
    } else if (
      this.model?.documentTypeId === FinancialDocumentTypesEnum.Isplatnica
    ) {
      return this.model.id != null
        ? this.$t("t.FinancialDocumentTypes.PaymentSlip.Withdrawal") +
            " " +
            (this.storedSettings?.setFiscalNumberAsMain
              ? this.fiscalNumber
              : this.model.documentInternalIdentifier)
        : this.$t("FinancialDocument.New.PaymentSlip.Withdrawal");
    }
    return "";
  }

  get decimalSeparator() {
    const separator = Intl.NumberFormat(this.internalLanguage)
      .format(1.1)
      .replace(/\p{Number}/gu, "");
    return separator;
  }

  countDecimals(num: number) {
    return num.toString().split(this.decimalSeparator)[1]?.length || 0;
  }

  @Ref("form") formRef?: {
    reset: () => void;
    resetValidation: () => void;
    validate: () => boolean;
  };

  saving = false;
  messages: string[] = [];

  showMessages() {
    const formatSuccessMessages = (x: string[]) =>
      x
        .map((h) => this.$t(h).toString())
        .map((th) => (th.endsWith(".") ? th : th + "."))
        .join(" ");

    if (this.messages.length > 0) {
      this.$store.dispatch("showNotification", {
        color: "success",
        message: formatSuccessMessages(this.messages),
        timeout: 5000,
      });
    }

    this.messages = [];
  }

  async sleep() {
    await new Promise((resolve) => setTimeout(resolve, 150));
  }

  async submitDraft(overrides: string[]) {
    try {
      this.saving = true;
      await this.sleep();
      this.assertSubmitValidity();
      try {
        await this.submit(overrides);
        await this.refreshModelData();
        this.$emit("saved", this.model);
      } finally {
        this.showMessages();
        this.saving = false;
      }
      return true;
    } catch {
      this.saving = false;
      return false;
    }
  }

  assertSubmitValidity() {
    const formvalid = this.formRef?.validate() ?? false;

    if (!formvalid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Validation.InputErrors"),
        timeout: 5000,
      });
      throw new Error("Validation.InputErrors");
    }
  }

  async submit(overrides: string[]) {
    const formatBrokenRuleNames = (x: string[]) =>
      x
        .map((h) => this.$t(h).toString())
        .map((th) => (th.endsWith(".") ? th : th + "."))
        .join(" ");

    const isOverriding = overrides.length !== 0;

    const handleCodes = [
      //"PaymentSlip.Deposit.WrongValue",
      //"PaymentSlip.Withdrawal.WrongValue",
    ] as string[];
    const adapter = handleBrokenRuleAdapter(this.axios, handleCodes);

    this.saving = true;
    await Vue.axios
      .post(
        "financialDocuments/CreatePaymentSlip",
        {
          transactionDate: this.model?.transactionDate,
          transactionTime: this.model?.transactionTime,
          customerId: this.model?.customerId,
          documentTypeId: this.model?.documentTypeId,
          transactionDescriptionId: this.model?.transactionDescriptionId,
          cashRegisterId: this.model?.cashRegisterId,
          businessUnitId: this.model?.businessUnitId,
          amount: this.model?.amount,
          currencyId: this.model?.currencyId,
          additionalTransactionNote: this.model?.additionalNoteForTransaction,
          overrideRules: overrides,
        },
        isOverriding ? undefined : { adapter }
      )
      .then((res) => {
        const result = res.data as PaymentSlipSaveResult;
        if (this.model) {
          this.model.id = result.id;
        }

        this.model?.documentTypeId === FinancialDocumentTypesEnum.Uplatnica
          ? this.$store.dispatch("showNotification", {
              color: "success",
              message: this.$t(
                "FinancialDocument.PaymentSlip.Deposit.SaveSuccess"
              ),
              timeout: 5000,
            })
          : this.$store.dispatch("showNotification", {
              color: "success",
              message: this.$t(
                "FinancialDocument.PaymentSlip.Withdrawal.SaveSuccess"
              ),
              timeout: 5000,
            });
      })
      .catch((x) => {
        if (x && x.isHandleBrokenRuleResult && !isOverriding) {
          this.$store.dispatch("showNotification", {
            color: "warning",
            message:
              // prettier-ignore
              `${formatBrokenRuleNames(x.handled)} ${this.$t("Do you wish to continue anyway?")}`,
            timeout: 10000,
            actions: [
              {
                text: this.$t("Yes"),
                fun: () => {
                  this.submitDraft(x.handled);
                  return true;
                },
              },
              { text: this.$t("Cancel"), fun: () => true },
            ],
          });
        } else {
          this.$store.dispatch("showNotification", {
            color: "error",
            message: `${formatBrokenRuleNames(x.unhandled)}`,
            timeout: 5000,
          });
        }
      })
      .finally(() => {
        this.saving = false;
      });
  }

  async downloadPdfDocument() {
    if (!this.model) {
      return;
    }

    let synced = true;
    // ? if document is locked don't even try, it should already be saved
    // ? and no updates could be made anymore, this is non 100% needed, but a check
    // ? to prevent future possible bugs
    if (this.model.id === null) {
      // saving so pending clientside changes dont differ from backend data
      // and document is the same
      synced = await this.submitDraft([]);
    }

    if (synced == true) {
      try {
        // retain saving flag while waiting on pdf download
        this.saving = true;
        const res = await this.axios.get(
          `financialDocuments/${this.model.id}/pdfDocument`,
          {
            params: {
              $skip: 0,
              $top: null,
            },
            responseType: "blob",
          }
        );
        const groups = /filename=(?<filename>[^;]+);/.exec(
          res.headers["content-disposition"]
        )?.groups;

        saveFile(res.data, groups?.filename ?? "payment_slip.pdf");

        return res;
      } finally {
        this.saving = false;
      }
    }
  }

  close() {
    if (isEqual(this.model, this.original)) {
      this.isOpen = false;
      this.current = null;
    } else {
      this.$store.dispatch("showNotification", {
        color: "warning",
        message: this.$t(
          "Changes pending. Are you sure you want to close the form?"
        ),
        actions: [
          {
            text: this.$t("Yes"),
            fun: () => {
              this.isOpen = false;
              this.current = null;
              return true;
            },
          },
          {
            text: this.$t("No"),
            fun: () => {
              return true;
            },
          },
        ],
        timeout: 5000,
      });
    }
  }

  async refreshModelData() {
    if (!this.model || !this.model.id) return;

    Vue.axios
      .get<PaymentSlipViewModel>(
        "financialDocuments/GetPaymentSlip/" + this.model.id
      )
      .then((res) => {
        if (!this.model || !this.model.id) return;

        const result = res.data;
        const issueDate = result.transactionDateTime.substring(0, 10);
        const issueTime = result.transactionDateTime.substring(11, 16);

        const newModel = {
          id: this.model.id,
          documentNumber: result.documentNumber,
          documentInternalIdentifier: result.documentInternalIdentifier,
          documentTypeId: result.documentTypeId,
          documentIdentifier: result.documentIdentifier,
          transactionDate: issueDate,
          transactionTime: issueTime,
          customerId: result.customerId,
          customerName: result.customerName,
          amount: result.transactionAmount,
          currencyId: result.currencyId,
          transactionDescriptionId: result.transactionDescriptionId,
          additionalNoteForTransaction: result.additionalNoteForTransaction,
          cashRegisterId: result.cashRegisterId,
          businessUnitId: result.businessUnitId,
        } as PaymentSlipModel;

        this.current = newModel;
        this.original = cloneDeep(this.model);
      })
      .catch(() => {
        this.$store.dispatch("showNotification", {
          color: "error",
          message: this.$t("Errors"),
          timeout: 5000,
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }
  disableFooterButtons = false;
}
